import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {MvsCrudService} from 'features/core/shared/service/crud/mvs-crud.service';
import {
    HelpAskRequestDto,
    HelpAskResponseDto,
    HelpConversationDto,
    HelpConversationMessageDto
} from '../../model/dto/help-chat.dto';

@Injectable({
    providedIn: 'root'
})
export class HelpChatService {

    private readonly apiUrl: string;

    constructor(private http: HttpClient) {
        this.apiUrl = MvsCrudService.baseUrl + '/cb/help';
    }

    ask(request: HelpAskRequestDto): Observable<HelpAskResponseDto> {
        return this.http.post<HelpAskResponseDto>(`${this.apiUrl}/ask`, request);
    }

    getConversations(moduleAlias?: string): Observable<HelpConversationDto[]> {
        let params = new HttpParams();
        if (moduleAlias) {
            params = params.set('moduleAlias', moduleAlias);
        }
        return this.http.get<HelpConversationDto[]>(`${this.apiUrl}/conversations`, {params});
    }

    getConversationMessages(conversationId: number): Observable<HelpConversationMessageDto[]> {
        return this.http.get<HelpConversationMessageDto[]>(`${this.apiUrl}/conversations/${conversationId}/messages`);
    }

    deleteConversation(conversationId: number): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/conversations/${conversationId}`);
    }
}
